import React, { useEffect, useState } from "react"
import BVASelect from "../../../../components/BVASelect/BVASelect";
import { connect } from "react-redux"
import { generateAltmanZScore, updateBusinessType } from "../../../../store/modules/financialRatios/actions";
import DateBar from "./DateBar";
import Subtitle from "./Subtitle";
import Item from "./Item";

const NON_MANUFACTURING = "NON_MANUFACTURING"
const PRIVATE_MANUFACTURING = "PRIVATE_MANUFACTURING"
const PUBLIC_MANUFACTURING = "PUBLIC_MANUFACTURING"

const typeOfBusiness = [
  { label: "Non Manufacturing", value: NON_MANUFACTURING },
  { label: "Private Manufacturing", value: PRIVATE_MANUFACTURING },
  { label: "Public Manufacturing", value: PUBLIC_MANUFACTURING },
]

function AltmanZScore({
  dispatchGenerateAltmanZScore,
  dispatchUpdateBusinessType,
  currentCompanyAltmanZScore,
  dateOrder,
  prefix,
}) {

  const [selectedSection, setSelectedSection] = useState(currentCompanyAltmanZScore?.businessType || "PRIVATE_MANUFACTURING");

  // Mounted
  useEffect(() => {
    handleGenerateAltmanZScore();
  }, [])

  // Methods
  const handleGenerateAltmanZScore = async () => {
    await dispatchGenerateAltmanZScore({ dateOrder, prefix });
  };

  const handleBusinessTypeOnChange = (businessType) => {
    dispatchUpdateBusinessType(businessType);
    setSelectedSection(businessType);
  };

  return (
    <div className="overflow-auto">

      <DateBar />

      <Subtitle title="Select Type of Business" percent = {true} />

      <div className="mt-10" />
      <BVASelect
        items={typeOfBusiness}
        value={selectedSection}
        width="24em"
        placeholder="Select a section"
        onChange={(value) => handleBusinessTypeOnChange(value)}
      />

      <Subtitle title="Base Calculations" percent = {true} />

      <Item label = "WC ÷ Total Assets" percent = {true} />
      <Item label = "Retained Earnings ÷ Total Assets" percent = {true} />
      <Item label = "EBIT ÷ Total Assets" percent = {true} />
      <Item label = "Book Value of Equity ÷ Total Liabilities" percent = {true} />
      <Item label = "Sales ÷ Total Assets" percent = {true} />

      <Subtitle title="Z Score" />

      <Item label = "Z Score" bold = {true} />
      <Item label = "Zone" bold = {true} />

      <div className="mb-10" />
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateAltmanZScore({ dateOrder, prefix }) {
    await dispatch(generateAltmanZScore({ dateOrder, prefix }))
  },
  async dispatchUpdateBusinessType(businessType) {
    await dispatch(updateBusinessType(businessType))
  },
})

const mapStateToProps = (state) => ({
  currentCompanyAltmanZScore: state.financialRatios.currentCompanyAltmanZScore
});

export default connect(mapStateToProps, mapDispatchToProps)(AltmanZScore)
